import React from 'react';

const InvoiceField = ({ onEditItem, cellData }) => {
  return (
    <input
      className={`${cellData.className} bg-gray-100 border border-[#dcdfe6] rounded box-border h-[35px] leading-[35px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500`}
      type={cellData.type}
      placeholder={cellData.placeholder}
      min={cellData.min}
      max={cellData.max}
      step={cellData.step}
      name={cellData.name}
      id={cellData.id}
      value={cellData.value}
      onChange={onEditItem}
      required
    />
  );
};

export default InvoiceField;
